import React, { useEffect, useState } from "react";
import { PaginationShow } from "../../../comman/action/Pagination";
import NotFound from "../../../components/not-found/NotFound";
import MonetizationOnTwoToneIcon from "@mui/icons-material/MonetizationOnTwoTone";
import useDebounce from "../../../hooks/useDebounce";
import { cashConverter } from "../../../components/Form";

const ReceivedFunds = ({ listing, page }) => {
  return (
    <>
      <div className="content-table">
        <table>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Username</th>
              <th>Email address</th>
              <th>Method of earning</th>
              <th>Received Amount</th>
              <th>Modify Amount</th>
            </tr>
          </thead>
          <tbody>
            {listing.length > 0 ? (
              listing.map(
                (
                  {
                    _id,
                    type,
                    fundsInvested,
                    name,
                    userId,
                    amount,
                    modifyAmount,
                  },
                  index
                ) => {
                  return (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{++index + (page - 1) * 10}</td>
                        <td>{name || "N/A"}</td>
                        <td>{userId?.email || "N/A"}</td>
                        <td>{type || "N/A"}</td>
                        <td>{cashConverter(amount) || "N/A"}</td>
                        <td>
                          {modifyAmount ? cashConverter(modifyAmount) : "N/A"}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                }
              )
            ) : (
              <NotFound
                cols={10}
                msg="No Received Funds Found!"
                icon={<MonetizationOnTwoToneIcon style={{ fontSize: 48 }} />}
              />
            )}
          </tbody>
        </table>
      </div>
      {/* -------pagination--------- */}
      {/* <PaginationShow
        total={total}
        activePage={page}
        handlePageChange={handlePageChange}
      /> */}
    </>
  );
};

export default ReceivedFunds;
